import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const Pagination = ({ currentPage, totalPages, handlePageChange, isArabic }) => {
  return (
    <div className="mt-4">
      <ul className="flex justify-center items-center space-x-2">
        <li>
          <button
            className="px-3 py-1 rounded-full text-primary-blue"
            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            {isArabic ? <FaArrowRight /> : <FaArrowLeft />}
          </button>
        </li>
        {Array.from({ length: totalPages }, (_, index) => (
          <li key={index}>
            <button
              className={`px-3 py-1 rounded-full ${
                currentPage === index + 1
                  ? "bg-primary-blue text-white"
                  : "text-gray-700"
              }`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          </li>
        ))}
        <li>
          <button
            className="px-3 py-1 rounded-full text-primary-blue"
            onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            {isArabic ? <FaArrowLeft /> : <FaArrowRight />}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
